<button (click)="share()" aria-label="telegram share">
  <i class="icon-telegram"></i>
</button>